import { useEffect } from "react";
import AppPage from "../AppPage";
import { globals, images } from "../../styles";
import { arrow_Icon, eye_Icon } from "../../assets/icons";
import { useNavigate } from "../../hooks/useNavigate";
import { Page } from "../../types";
import MenuButtonBar, { MenuBarItem } from "../MenuBottomBar";
import { useNewsArticle } from "../../hooks/useNewsArticle";
import big_News from "../../assets/NewsImages/BigImg.png";
import styles from "./NewsArticle.module.css";
import {
  chapelle,
  dave,
  gracie,
  jimin,
  sml1_News,
  sml2_News,
  sml3_News,
  sml4_News,
} from "../../assets/NewsImages";

const newsItems = [
  {
    image: big_News,
    headline:
      "Fans Choose Bruno Mars' 'I Just Might' as This Week's Favorite New Music",
    source: "Billboard",
    time: "2 hrs ago",
    article: [
      "\u201CI Just Might,\u201D the new single from Bruno Mars, tops this week\u2019s fan-voted music poll.",
      "Music fans voted in a poll published Friday (Jan. 9) on Billboard, choosing the singer\u2019s fresh arrival as their favorite new drop.",
      "\u201CI Just Might\u201D was released in a week that also saw new music streaming in from The Kid LAROI, Zach Bryan, Robyn and more. Bruno Mars maintained a strong lead up until the poll\u2019s closing on Sunday, ultimately surpassing 71% of the vote.",
      "It\u2019s been almost 10 years since Bruno Mars released a new solo album (following 2016\u2019s 24K Magic, which peaked at No. 2 on the Billboard 200). New set The Romantic, his fourth full-length collection, is due Feb. 27 from Atlantic Records. \u201CI Just Might\u201D and its official music video \u2014 which the artist himself co-directed (with Daniel Ramos) and co-choreographed (alongside Phil Tayag) \u2014 offers a first taste of his new work.",
      "Last week also brought the reveal of the pop star\u2019s upcoming Romantic Tour, which launches in April and runs through October across North America, Canada and Europe. Presale tickets will be available beginning Jan. 14, with a general on-sale coming a day later.",
      "Among the new releases trailing behind \u201CI Just Might\u201D are The Kid LAROI\u2019s Before I Forget EP (with 17% of the vote), Zach Bryan\u2019s With Heaven on Top album (with 3% of the vote) and Robyn\u2019s new single \u201CTalk to Me\u201D and (with 2% of the vote).",
    ],
  },
  {
    image: chapelle,
    headline: "Chappell Roan's Love Letter to the LGBTQ Community",
    source: "Billboard",
    time: "2 hrs ago",
    article: [
      "A love letter doesn\u2019t seem near enough for you. Sitting down racking my brain, trying to shove love into a few paragraphs doesn\u2019t do you justice. The appreciation doesn\u2019t fit into my vocabulary. The best I can do is offer you my project, my songs, my tears, & my eternal love for queerness.",
      "Growing up Christian, thinking being gay was a choice, cast a shell over my heart that could only be broken by your joy and grace towards my scared and confused 18 year old self who thought maybe liking girls wasn\u2019t just a phase anymore. Leaving my religious community to start a new life in Los Angeles was rewarded by the queer community taking me under your wing and nursing me to a happiness I\u2019ve never felt before.",
      "\u201CThank God I\u2019m gay\u201D is a sentence I thought I\u2019d never say, but it\u2019s true. Thank God I love women. Thank God you taught me to accept myself, inspired me to dress loud, and and dance the way I have dreamt of since I was nine. Thank God you support me and I have the privilege to watch you from the stage radiating freedom and beaming with smiles. Thank God for drag performers. Thank God for strap-ons. Thank God for you.",
      "With eternal love,\nChappell Roan",
    ],
  },
  {
    image: dave,
    headline: "Farm Aid 2025 to Air Live on CNN to Celebrate 40 Years",
    source: "Billboard",
    time: "2 hrs ago",
    article: [
      "This year, Farm Aid will take place in Minneapolis \u2014 but fans don\u2019t need to be anywhere near Minnesota to catch the festival. As Billboard is exclusively announcing Wednesday morning (Sept. 3), CNN will help celebrate the annual event\u2019s 40th anniversary by livestreaming sets from Willie Nelson, Neil Young, John Mellencamp and more stars later this month.",
      "CNN\u2019s coverage of the music and food summit \u2014 which is this year being held at Huntington Bank Stadium \u2014 will take place from 7 p.m. to midnight ET on Saturday, Sept. 20. Viewers can tune in by streaming the presentation live on CNN, CNN.com or via CNN\u2019s TV and mobile apps \u2014 no cable login needed.",
      "\u201CCNN is proud to join Farm Aid 40 to help bring attention to our nation\u2019s farmers and agricultural communities,\u201D Eric Sherling, the network\u2019s executive vp of U.S. programming, said in a statement. \u201CThe broadcast of Farm Aid 40 is another example of CNN\u2019s commitment to live programming and bringing viewers important cultural moments as they happen.\u201D",
      "In addition to Nelson, Young and Mellencamp \u2014 who founded Farm Aid in 1985 to raise funds for the country\u2019s agricultural community \u2014 this year\u2019s lineup will include Dave Matthews, Margo Price, Kenny Chesney, Billy Strings, Nathaniel Rateliff & The Night Sweats, Lukas Nelson, Trampled by Turtles, Wynonna Judd, Steve Earle, Waxahatchee, Eric Burton of Black Pumas, Jesse Welles, Madeline Edwards and Wisdom Indian Dancers. CNN anchors John Berman and Laura Coates will helm the live special, while chief climate correspondent Bill Weir is slated to deliver on-the-ground reporting.",
      "\u201CFarm Aid is honored to partner with CNN to bring Farm Aid 40 to a broad and diverse audience,\u201D added Farm Aid co-director Jennifer Fahy. \u201CThis partnership is critical to elevating the role of family farmers to their rightful place as essential for all of us and showcasing the extraordinary artists who have generously shared their voices of support for 40 years.\u201D",
      "In the four decades since the very first Farm Aid took place in Philadelphia, the event has raised more than $85 million to support farmers and their families across the United States. It\u2019s a cause that hits close to home for the event\u2019s founders, even all this time later.",
      "\u201CFarming was my first job,\u201D Nelson told Billboard in 2015. \u201CI picked cotton. I pulled corn. I knew firsthand what it meant to farm. I knew damn well how tough it was. My farm roots are deep-seated in the soil of my personal story.\u201D",
      "For those who\u2019d like to attend in-person, tickets for Farm Aid 40 are available to purchase through the University of Minnesota\u2019s website.",
    ],
  },
  {
    image: gracie,
    headline: "Gracie Abrams Set to Make Acting Debut in A24's 'Please'",
    source: "Billboard",
    time: "2 hrs ago",
    article: [
      "Gracie Abrams is heading to Hollywood. According to Deadline, the Grammy-nominated singer has been cast in the lead role of A24\u2019s forthcoming film, Please.",
      "The role will mark Abrams\u2019 debut on the silver screen as an actress, while renowned filmmaker Halina Reijn is on board to direct the A24-produced project. Reijn previously teamed up with A24 to helm films like Babygirl and Bodies Bodies Bodies.",
      "The singer has family ties to generations of decorated filmmakers. Gracie\u2019s father, JJ Abrams, has a Hollywood r\u00E9sum\u00E9 that includes writing Forever Young and Armageddon. He also directed Star Trek as well as Star Wars sequels The Force Awakens and The Rise of Skywalker. For his next project, Abrams will helm The Great Beyond, starring Jenna Ortega and Glen Powell.",
      "Gracie Abrams\u2019 grandmother, Carol Abrams, is a Peabody Award winner, while her grandfather, Gerald Abrams, has also been nominated for an Emmy Award.",
      "During Abrams\u2019 April 2025 Billboard cover story, the \u201CThat\u2019s So True\u201D singer was very coy about her Hollywood aspirations, but admitted she has \u201Cloads of ambitions\u201D outside of singing and songwriting. \u201CI don\u2019t know what I want to attempt to speak into existence at this point in time,\u201D Abrams cryptically said when asked about potentially acting in the future.",
      "On the music front, the 26-year-old pop star leveled up with the release of her The Secret of Us album in June 2024, which peaked at No. 2 on the Billboard 200. Abrams headed out on a subsequent tour in support of her sophomore LP, and her 2025 U.S. leg marked her first run of headlining arena shows last summer.",
      "There has been plenty of crossover when it comes to music artists jumping into the A24 universe of movies. Tyler, the Creator starred in Marty Supreme to close out 2025 and the company is producing Charli xcx\u2019s The Moment film, which arrives on Jan. 30.",
    ],
  },
  {
    image: jimin,
    headline: "Jimin's 'Closer Than This' Is Here: Watch the Music Video",
    source: "Billboard",
    time: "2 hrs ago",
    article: [
      "Jimin is the holiday gift that keeps on giving! The BTS superstar had one last surprise for fans this year when he unveiled his new single, \u201CCloser Than This\u201D on Friday (Dec. 22).",
      "BigHit announced the single earlier this week via Weverse, adding that \u201CCloser Than This\u201D is a \u201Cheartfelt fan song that encapsulates Jimin\u2019s genuine feelings for ARMY.\u201D",
      "\u201CAs we approach the final days of 2023, we hope that \u2018Closer Than This,\u2019 with its lyrics conveying Jimin\u2019s love and affection for his fans, will bring you hope and warmth,\u201D BigHit added.",
      "It\u2019s been a big year for Jimin, who dropped his EP Face in March, and the project subsequently peaked at No. 2 on the Billboard 200. One of the EP\u2019s singles, \u201CLike Crazy,\u201D topped the Billboard Hot 100 in April, becoming the singer\u2019s first No. 1 on the chart as a soloist.",
      "He was also a top nominee at the 2023 MAMA Awards in November with eight nods. He ultimately took home the best male artist award. \u201CToday we received so many valuable awards today,\u201D he wrote to fans afterward on Weverse. \u201CThank you very much to all ARMYs who always support and love us. We will do our best to show you better music and performances. Thank you again and I love you.\u201D",
      "Jimin and bandmate Jung Kook began their military service on Dec. 12, according to the Associated Press. In addition, fellow BTS members RM and V enlisted a day earlier, while Suga, Jin and J-Hope have already been serving.",
    ],
  },
];

function NewsArticlePage() {
  const { navigate } = useNavigate();
  const { articleIndex, markAsViewed } = useNewsArticle();
  const item = newsItems[articleIndex];

  useEffect(() => {
    markAsViewed(articleIndex);
  }, [articleIndex, markAsViewed]);

  return (
    <AppPage
      className={globals["page"]}
      bottomBar={
        <MenuButtonBar
          items={[
            MenuBarItem.Home,
            MenuBarItem.Leaderboards,
            MenuBarItem.Groups,
            MenuBarItem.LogOut,
          ]}
        />
      }
    >
      <button
        className={`${globals["button-wrapper"]} ${globals["back-btn--top-left"]}`}
        onClick={() => navigate(Page.News)}
      >
        <div className={globals["back-btn"]}>
          <img src={arrow_Icon} alt="" />
        </div>
      </button>
      <span className={globals["news-heading"]}>News</span>
      <div className={styles["article-scroll"]}>
        <img src={item.image} alt="" className={styles["article-image"]} />
        <span className={styles["article-headline"]}>{item.headline}</span>
        <div className={styles["article-meta"]}>
          <span className={styles["article-source"]}>{item.source} -</span>
          <span className={styles["article-source"]}>{item.time}</span>
          <img
            src={eye_Icon}
            className={`${images["news-eye"]} ${styles["news-eye"]}`}
            alt=""
          />
        </div>
        {item.article.length > 0 && (
          <div className={styles["article-body"]}>
            {item.article.map((paragraph, i) => (
              <p key={i} className={styles["article-paragraph"]}>
                {paragraph}
              </p>
            ))}
          </div>
        )}
      </div>
    </AppPage>
  );
}

export default NewsArticlePage;
